module.exports = __webpack_public_path__ + "img/caseBuilder-pilot.da06323d.webp";